import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

/**
 * Componente middleware para interceptar e redirecionar acessos indevidos ao dashboard
 */
const DashboardRedirectMiddleware = () => {
  const { hasRole } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Verificar se estamos usando uma navegação baseada em hash
    const isHashRouter = window.location.href.includes('#/');
    
    // O expositor não deve acessar o dashboard
    if (!hasRole('admin')) {
      // Verificar se o caminho atual contém "dashboard"
      const isDashboardRoute = isHashRouter 
        ? window.location.hash.includes('/dashboard')
        : location.pathname.includes('/dashboard');
      
      if (isDashboardRoute) {
        console.log('Acesso não autorizado ao dashboard. Redirecionando para a página inicial do expositor.');
        
        // Redirecionar para a página inicial do expositor
        navigate('/expositor-home', { replace: true });
      }
    }
  }, [location, hasRole, navigate]);
  
  return null; // Este componente não renderiza nada
};

export default DashboardRedirectMiddleware;